export const sliceArray = <T>(arr: T[], eleNum: number) => {
  return arr.reduce((acc, cur, index) => {
    const chunkIndex = Math.floor(index / eleNum)
    if (acc[chunkIndex] === undefined) acc[chunkIndex] = []
    acc[chunkIndex].push(cur)
    return acc
  }, [])
}
